<button mat-button class="close-icon" [mat-dialog-close]="false">
  <mat-icon>close</mat-icon>
</button>
<h1 mat-dialog-title class="text-center pt-3">Are you sure you want to create demo data for {{ data.name }}?</h1>
<div class="text-center alert alert-warning">
  <div class="warningTitle">Please note that this operation will create:</div>
  <div>
    <ul class="list-group">
      <li *ngFor="let item of data.information" class="list-information-item">
        {{ item }}
      </li>
    </ul>
  </div>
</div>
<div mat-dialog-content class="text-center">
  <div class="alert alert-danger">
    Please confirm by entering the word
    <strong>"{{ this.operation.toUpperCase() }}"</strong> in the box below.
  </div>
  <mat-form-field floatLabel="never" appearance="outline">
    <input type="text" matInput [(ngModel)]="currentValue" value="{{ currentValue }}" />
    <mat-icon matSuffix class="pointer" (click)="clearField()">clear</mat-icon>
  </mat-form-field>
</div>
<div mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial mat-raised-button color="warn">CANCEL</button>
  <button
    class="btn"
    mat-stroked-button
    color="warn"
    [disabled]="currentValue != this.operation.toUpperCase()"
    (click)="create()"
  >
    CREATE
  </button>
</div>
